import {
  FilterFieldLayout,
  FilterSectionLayout
} from 'site/Renderer/components/FilterFields/types'

export function findSectionLayoutField(
  sectionsLayout: FilterSectionLayout[] | undefined,
  fieldUuid: string
): FilterFieldLayout | undefined {
  return sectionsLayout
    ?.flatMap((section) => section.filter_fields)
    .find((field) => field?.field_uuid === fieldUuid)
}
